<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Tantárgyfelosztás</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" *ngIf="user$"><br>
  <ng-container *ngIf="!canViewTtf">
    Nincs jogosultsága az oldal megtekintéséhez!
  </ng-container>
  <ng-container *ngIf="canViewTtf">

    <ion-grid>
      <!-- 20/2012. EMMI r. 105. § (3): a tantárgyfelosztást augusztus 15-ig meg kell küldeni a fenntartónak. -->
      <ion-row *ngIf="jog.figyelmeztetes() as fm">
        <ion-col>
          <ion-note [color]="fm.allapot === 'lejart' ? 'danger' : 'warning'" style="display:block;font-weight:600;padding:4px 8px">
            <ion-icon name="alert-circle-outline" style="vertical-align:middle"></ion-icon>
            {{ fm.szoveg }}
            <a href="javascript:void(0)" (click)="segment = 'jogszabaly'" *ngIf="segment !== 'jogszabaly'">Megküldés rögzítése</a>
          </ion-note>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="ttfstatus && (ttfstatus.status == 4 || ttfstatus.status == 3)">

        <ion-col>
          <ion-card>
            <ion-card-content>
              <ion-card-title>
                A tantárgyfelosztás az alábbi ok miatt  
                <span *ngIf="ttfstatus && ttfstatus.status == 4">elutasításra</span>
                <span *ngIf="ttfstatus && ttfstatus.status == 3">elfogadásra</span>
                 került:</ion-card-title></ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
      <ion-row>

        <ion-col>
          <ion-card>
            <ion-card-header>
              <ion-card-title>Tantárgyfelosztás<ion-button (click)="printData2()" style="float:right">
                <ion-icon slot="icon-only" name="print-outline"></ion-icon>
              </ion-button><!-- Van óra, de nincs mögötte felosztás-sor? Onnan a kolléga
                nem tud tanmenetet feltölteni. Ez a gomb az órarendből pótolja. -->
              <ion-button (click)="visszatoltesNyit()" style="float:right" fill="outline"
                          title="A hiányzó felosztás-sorok pótlása a meglévő órarendből">
                <ion-icon slot="start" name="download-outline"></ion-icon>Visszatöltés az órarendből
              </ion-button><ion-button (click)="printData2()" style="float:right" color="success" *ngIf="ttfstatus && ttfstatus.status == 1">
                <ion-icon slot="start" name="checkmark"></ion-icon>Tantárgyfelosztás elfogadása
              </ion-button><ion-button (click)="printData2()" style="float:right" color="danger" *ngIf="ttfstatus && ttfstatus.status == 1">
                <ion-icon slot="start" name="close"></ion-icon>Tantárgyfelosztás elutasítása
              </ion-button><ion-button style="float:right" color="tertiary" disabled *ngIf="ttfstatus && ttfstatus.status == 1">
                <ion-icon slot="start" name="chatbox-ellipses"></ion-icon>Tantárgyfelosztás elfogadása folyamatban
              </ion-button><ion-button style="float:right" color="success" disabled *ngIf="ttfstatus && ttfstatus.status == 3">
                <ion-icon slot="start" name="checkmark-done"></ion-icon>Tantárgyfelosztás elfogadva
              </ion-button><ion-button style="float:right" color="danger" disabled *ngIf="ttfstatus && ttfstatus.status == 4">
                <ion-icon slot="start" name="close"></ion-icon>Tantárgyfelosztás elutasítva
              </ion-button></ion-card-title>
            </ion-card-header>

            <ion-card-content>

             <div class="ttf-work" #ttfWork>

              <!-- Teljes képernyős fejléc (csak fullscreen módban) -->
              <div class="fs-bar" *ngIf="fullscreen">
                <b>Tantárgyfelosztás</b>
                <ion-button size="small" fill="solid" color="medium" (click)="toggleFullscreen()">
                  <ion-icon slot="start" name="contract-outline"></ion-icon>Kilépés a teljes képernyőből
                </ion-button>
              </div>

              <!-- Vezérlők: tanév-választó + nézetváltó + teljes képernyő -->
              <ion-toolbar>
                <ion-item slot="start" lines="none">
                  <ion-label>Tanév:</ion-label>
                  <ion-select [value]="akttev" interface="popover" (ionChange)="changeEv($event)">
                    <ion-select-option *ngFor="let ty of tanevadatok" [value]="ty.id">{{ty.name}}</ion-select-option>
                  </ion-select>
                </ion-item>
                <ion-segment [(ngModel)]="segment" (ionChange)="segmentValtas($event)" slot="end" style="max-width:640px" [scrollable]="true">
                  <ion-segment-button value="ttf"><ion-label>Tantárgyfelosztás</ion-label></ion-segment-button>
                  <ion-segment-button value="tanarok"><ion-label>Tanárok óraszáma</ion-label></ion-segment-button>
                  <ion-segment-button value="tanar"><ion-label>Tanár szerint</ion-label></ion-segment-button>
                  <ion-segment-button value="asc"><ion-label>aSc export</ion-label></ion-segment-button>
                  <ion-segment-button value="jogszabaly"><ion-label>105. § adatok</ion-label></ion-segment-button>
                </ion-segment>
                <ion-buttons slot="end">
                  <ion-button fill="solid" color="tertiary" (click)="toggleFullscreen()">
                    <ion-icon slot="start" name="expand-outline"></ion-icon>Teljes képernyő
                  </ion-button>
                </ion-buttons>
              </ion-toolbar>

              <ion-item *ngIf="!ttf" lines="none">
                <ion-label>Betöltés...</ion-label>
                <ion-spinner color="primary" name="crescent"></ion-spinner>
              </ion-item>

              <!-- FŐ NÉZET: kompakt (tantárgy × évfolyam) lista, tanáronkénti oszlopok nélkül -->
              <div class="scrollable-table printable" *ngIf="segment=='ttf'">
                <table id="printable2" class="ttf-grid">
                  <thead>
                    <tr class="green">
                      <th>Osztály</th>
                      <th>Tantárgy</th>
                      <th>Heti óra</th>
                      <th>Csoportok / bontás</th>
                      <th>Kiosztott</th>
                      <th>Művelet</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- HIÁNYOS rács: van osztály, de arra az évfolyamra nincs óraterv.
                         Enélkül az osztály sehol nem jelenik meg a tantárgyfelosztásban. -->
                    <tr *ngIf="ttf && ttf.length && (hianyzoOraterv.length || torzsadatHianyok.length)">
                      <td colspan="6" class="ures-magyarazat">
                        <div *ngIf="hianyzoOraterv.length">
                          <b>Hiányzó óraterv:</b> az alábbi évfolyamokhoz van osztály, de erre a tanévre
                          nincs kerettanterv, ezért nem jelennek meg a rácsban –
                          <span *ngFor="let h of hianyzoOraterv; let last = last">
                            <b>{{h.evfolyam}}. évfolyam</b> ({{h.osztalyok}}){{ last ? '' : ', ' }}</span>.
                          Vidd fel az óratervet (Admin → Kerettanterv), és a rácsban is megjelennek.
                        </div>
                        <div *ngIf="torzsadatHianyok.length">
                          <b>Hiányzó törzsadat erre a tanévre:</b>
                          <span *ngFor="let h of torzsadatHianyok; let last = last">{{h}}{{ last ? '' : '; ' }}</span>.
                        </div>
                      </td>
                    </tr>
                    <tr *ngIf="ttf && ttf.length==0">
                      <td colspan="6" class="ures-magyarazat">
                        <ng-container *ngIf="!tanevDiagnosztika">Nincs adat ehhez a tanévhez.</ng-container>
                        <ng-container *ngIf="tanevDiagnosztika">
                          <b>A rács üres, mert ehhez a tanévhez nincs kerettanterv (óraterv) rögzítve.</b>
                          <div>
                            A tantárgyfelosztás rácsa a kerettanterv soraiból épül fel
                            (tantárgy × évfolyam × heti óraszám), ezért kerettanterv nélkül
                            nincs mit megjeleníteni.
                          </div>
                          <div *ngIf="tanevDiagnosztika.ttf > 0" class="ures-figyelmeztetes">
                            Ehhez a tanévhez <b>{{tanevDiagnosztika.ttf}}</b> tantárgyfelosztás-sor
                            van rögzítve<span *ngIf="tanevDiagnosztika.ttf_arva > 0">, de közülük
                            <b>{{tanevDiagnosztika.ttf_arva}}</b> már nem létező kerettanterv-sorra
                            hivatkozik (törölt óraterv), ezért sehol nem jelenik meg</span>.
                            Ezt csak az óraterv (kerettanterv) újrarögzítésével lehet helyreállítani.
                          </div>
                        </ng-container>
                      </td>
                    </tr>
                    <tr *ngFor="let t of ttf; let i = index">
                      <td [class]="isBontva(t.ttfel, 0, 0, t.eddigi, t.db, 1)">{{replaceAccentedChars(t.evfolyam.osztaly)}}</td>
                      <td [class]="isBontva(t.ttfel, 0, 0, t.eddigi, t.db, 1)">{{replaceAccentedChars(t.nev)}}</td>
                      <td>{{t.db}}</td>
                      <td class="csoport-cell">
                        <ng-container *ngFor="let c of csoportChips(t)">
                          <ion-chip outline="true" [color]="c.idegen ? 'warning' : 'primary'"
                                    [title]="c.idegen ? 'Ez a kiírás egy másik tanév (vagy törölt) csoportjára mutat, ezért a tanár óraszámába nem számít bele. A Szerkesztésben törölhető.' : ''">
                            <ion-label>
                              <ion-icon *ngIf="c.idegen" name="warning-outline"></ion-icon>
                              <b *ngIf="c.name">{{c.name}}</b>
                              <span *ngIf="c.idegen"> ({{ c.idegenEv ? c.idegenEv + '. tanévi csoport' : 'törölt csoport' }} – nem számít bele)</span>
                              <span *ngIf="c.osztalyok && c.osztalyok.length"> [{{joinClasses(c.osztalyok)}}]</span>
                              · {{c.teachers.join(', ')}} · {{c.db}} ó<span *ngIf="c.terem"> · {{c.terem}}</span>
                            </ion-label>
                          </ion-chip>
                        </ng-container>
                        <span *ngIf="!t.ttfel || t.ttfel.length==0" class="muted">nincs csoport</span>
                      </td>
                      <td [class]="getColor(t.eddigi, t.db)">{{t.eddigi}} / {{t.db}}</td>
                      <td>
                        <ion-button size="small" *ngIf="isadmin" (click)="openEditor(t)">
                          <ion-icon slot="start" name="create-outline"></ion-icon>Szerkesztés
                        </ion-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- TANÁR-ÖSSZESÍTŐ NÉZET: egy sor / tanár -->
              <div class="scrollable-table" *ngIf="segment=='tanarok'">
                <table class="ttf-grid">
                  <thead>
                    <tr class="green">
                      <th>Tanár</th>
                      <th>Kinevezés</th>
                      <th>Osztályfőnök</th>
                      <th>Kötelező óraszám</th>
                      <th>Kiosztott óra</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let user of ports">
                      <td>{{replaceAccentedChars(user.viselt_vez)}} {{replaceAccentedChars(user.viselt_ker)}}</td>
                      <td><ng-container *ngIf="user.kinevezes.indexOf('null') != -1">-</ng-container><ng-container *ngIf="user.kinevezes.indexOf('null') == -1">{{user.kinevezes}}</ng-container></td>
                      <td><ng-container *ngIf="!user.of">-</ng-container><ng-container *ngFor="let o of osztaly"><ng-container *ngIf="o.of==user.adid">{{o.osztaly}}</ng-container></ng-container></td>
                      <td>{{kotelezoOra(user) | number: '1.0-1'}}</td>
                      <td [class]="getColor(user.osszora, kotelezoOra(user))">{{user.osszora}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- TANÁR SZERINTI NÉZET: egy tanár összes beosztott órája -->
              <div class="tanar-nezet" *ngIf="segment=='tanar'">
                <div class="tanar-valaszto">
                  <ion-searchbar placeholder="Tanár keresése..." [(ngModel)]="tanarKereso" [debounce]="150"></ion-searchbar>
                  <div class="tanar-lista">
                    <ion-item *ngFor="let p of tanarValaszto()" button lines="full"
                              [color]="p.adid == valasztottTanar ? 'light' : undefined"
                              (click)="valasztTanar(p.adid)">
                      <ion-label>
                        {{p.viselt_vez}} {{p.viselt_ker}}
                        <small class="muted"> · {{p.osszora || 0}} ó</small>
                      </ion-label>
                      <ion-icon *ngIf="p.adid == valasztottTanar" slot="end" name="checkmark" color="primary"></ion-icon>
                    </ion-item>
                    <ion-item *ngIf="tanarValaszto().length == 0" lines="none">
                      <ion-label class="muted">Nincs találat</ion-label>
                    </ion-item>
                  </div>
                </div>

                <div class="tanar-reszletek">
                  <ion-item lines="none" *ngIf="!valasztottTanar">
                    <ion-label class="muted">Válassz tanárt a bal oldali listából.</ion-label>
                  </ion-item>

                  <ng-container *ngIf="valasztottTanar">
                    <div class="tanar-fejlec">
                      <div>
                        <h2>{{valasztottTanarAdat?.viselt_vez}} {{valasztottTanarAdat?.viselt_ker}}</h2>
                        <p class="muted">
                          Kiosztott: <b [class]="getColor(tanarOsszOra(), tanarKotelezoOra())">{{tanarOsszOra()}}</b>
                          / kötelező: <b>{{tanarKotelezoOra()}}</b> óra
                          · Osztályfőnök: {{tanarOsztalyfonokseg()}}
                        </p>
                      </div>
                      <ion-button size="small" fill="outline" (click)="printTanar()">
                        <ion-icon slot="start" name="print-outline"></ion-icon>PDF
                      </ion-button>
                    </div>

                    <div class="scrollable-table">
                      <table class="ttf-grid">
                        <thead>
                          <tr class="green">
                            <th>Osztály</th>
                            <th>Tantárgy</th>
                            <th>Csoport</th>
                            <th>Heti óra</th>
                            <th>Terem</th>
                            <th>Társtanár</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let o of tanarOrai()">
                            <td>{{tanarOsztalyLista(o)}}</td>
                            <td>{{o.tantargy}}</td>
                            <td>
                              <span *ngIf="o.egeszOsztaly" class="muted">egész osztály</span>
                              <span *ngIf="!o.egeszOsztaly">{{o.csoportNev}}</span>
                              <small *ngIf="o.idegen" class="muted"> – {{ o.idegenEv ? o.idegenEv + '. tanévi' : 'törölt' }} csoport, nem számít bele (a Szerkesztésben törölhető)</small>
                            </td>
                            <td><s *ngIf="o.idegen">{{o.db}}</s><ng-container *ngIf="!o.idegen">{{o.db}}</ng-container></td>
                            <td>{{o.terem || '-'}}</td>
                            <td>{{o.tarsak.length ? o.tarsak.join(', ') : '-'}}</td>
                          </tr>
                          <tr *ngIf="tanarOrai().length == 0">
                            <td colspan="6" style="text-align:center">Ehhez a tanárhoz nincs beosztott óra ebben a tanévben.</td>
                          </tr>
                          <tr *ngIf="tanarOrai().length" class="green">
                            <td colspan="3"><b>Összesen</b></td>
                            <td><b>{{tanarOsszOra()}}</b></td>
                            <td colspan="2"></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </ng-container>
                </div>
              </div>

              <!-- aSc EXPORT: a tantárgyfelosztás kivitele aSc Órarendbe -->
              <div class="asc-export" *ngIf="segment=='asc'">
                <ion-item lines="none" *ngIf="!ascKatalogus">
                  <ion-label>Betöltés...</ion-label>
                  <ion-spinner color="primary" name="crescent"></ion-spinner>
                </ion-item>

                <ng-container *ngIf="ascKatalogus">
                  <ion-note color="medium" class="asc-info">
                    A tantárgyfelosztás kivitele az aSc Órarendbe (<b>{{tanev?.name || akttev}}</b>).
                    Az XML az aSc-ben <b>frissít</b>, nem duplikál: minden rekord a korábban használt
                    aSc azonosítót kapja, így egy aSc-ben átnevezett csoport/osztály a helyén marad.
                    Az aSc <b>csak a kiexportált mezőket írja felül</b> – amit itt nem pipálsz be,
                    az az aSc-ben beállított értéken marad (pl. az <b>osztályterem</b> soha nem kerül ki).
                    Kirakott órarendet (kártyákat) nem exportálunk – azt az aSc készíti, és a kész
                    órarend az <i>Admin → Import → aSc XML</i> ágon jön vissza.
                  </ion-note>

                  <div class="asc-grid">
                    <div class="asc-oszlop">
                      <h3>Mi kerüljön az exportba?</h3>
                      <ion-item *ngFor="let r of ascKatalogus.reszek" lines="full">
                        <ion-checkbox slot="start" [checked]="ascReszek[r.kulcs]"
                                      (ionChange)="ascReszek[r.kulcs] = $event.detail.checked"></ion-checkbox>
                        <ion-label>{{r.nev}}</ion-label>
                      </ion-item>
                    </div>

                    <div class="asc-oszlop">
                      <h3>Felülírható mezők</h3>
                      <p class="muted asc-magyarazat">
                        Csak a bepipált mezők kerülnek az XML-be, tehát csak azokat írja felül az aSc.
                      </p>
                      <div class="asc-szekcio" *ngFor="let szekcio of ascSzekciok()">
                        <b>{{szekcio.cim}}</b>
                        <ion-item *ngFor="let m of szekcio.mezok" lines="none" class="asc-mezo">
                          <ion-checkbox slot="start" [checked]="ascMezoBe(szekcio.kulcs, m.kulcs)"
                                        (ionChange)="ascMezoValt(szekcio.kulcs, m.kulcs)"></ion-checkbox>
                          <ion-label>{{m.nev}}</ion-label>
                        </ion-item>
                      </div>
                    </div>
                  </div>

                  <div class="asc-gombok">
                    <ion-button fill="outline" (click)="ascElonezet()" [disabled]="ascFolyamatban">
                      <ion-icon slot="start" name="eye-outline"></ion-icon>Előnézet
                    </ion-button>
                    <ion-button (click)="ascLetoltes()" [disabled]="ascFolyamatban">
                      <ion-icon slot="start" name="download-outline"></ion-icon>aSc XML letöltése
                    </ion-button>
                  </div>

                  <div class="asc-stat" *ngIf="ascStat">
                    <b>Előnézet:</b>
                    <span *ngFor="let s of ascStat.statisztika | keyvalue">
                      <ng-container *ngIf="s.key != 'hianyzoTanarok'">{{s.key}}: {{s.value}} · </ng-container>
                    </span>
                    <span>{{ascStat.meret}} byte</span>
                    <p class="asc-figyelmeztetes" *ngIf="ascStat.statisztika?.hianyzoTanarok?.length">
                      Figyelem: a tantárgyfelosztásban szerepel olyan tanár, aki nincs az intézmény
                      állományában, ezért az órájáról kimarad a tanár:
                      <b>{{ascStat.statisztika.hianyzoTanarok.join(', ')}}</b>
                    </p>
                  </div>
                </ng-container>
              </div>

              <!-- ── 105. § szerinti kötelező adatok (20/2012. EMMI r.) ── -->
              <div class="ttf-jogszabaly" *ngIf="segment=='jogszabaly'" style="padding:8px">
                <ion-note color="medium" style="display:block;font-size:.8rem;margin-bottom:8px">
                  A 20/2012. EMMI rendelet 105. § (2) bekezdése szerint a tantárgyfelosztás tartalmazza a pedagógus
                  sorszámát, nevét, végzettségét, szakképzettségét, tantárgyait és egyéb foglalkozásait, a lekötött
                  óraszámot, az órakedvezményre jogosító jogcímeket, az összesített óraszámokat és a fenntartó által
                  engedélyezett álláshelyek számát. A (3) bekezdés szerint jóváhagyásra minden év augusztus 15-ig meg
                  kell küldeni a fenntartónak. A tantárgyak és óraszámok a „Tantárgyfelosztás” fülről jönnek, a
                  kinevezésekhez tartozó órakedvezmény a Kinevezések képernyőről.
                </ion-note>
                <div *ngIf="jog.toltodik" class="ion-text-center"><ion-spinner name="crescent"></ion-spinner></div>
                <ion-note color="danger" *ngIf="jog.hiba">{{ jog.hiba }}</ion-note>

                <ng-container *ngIf="jog.adat && !jog.toltodik">
                  <!-- Tanév-szintű adatok -->
                  <ion-card style="margin:0 0 10px">
                    <ion-card-header>
                      <ion-card-subtitle>
                        {{ jog.adat.intezmeny?.nev }} – {{ jog.adat.tanev_nev }}. tanév
                        <ion-badge [color]="jog.megkuldesSzin()" style="margin-left:6px">{{ jog.adat.megkuldes?.szoveg }}</ion-badge>
                      </ion-card-subtitle>
                    </ion-card-header>
                    <ion-card-content>
                      <div style="display:flex;flex-wrap:wrap;gap:8px;align-items:flex-end">
                        <ion-input style="max-width:200px" label="Engedélyezett pedagógus-álláshelyek" label-placement="stacked" type="number"
                                   [(ngModel)]="jog.tanev.allashely"></ion-input>
                        <ion-input style="max-width:190px" label="Nevelőtestület véleményezte" label-placement="stacked" type="date"
                                   [(ngModel)]="jog.tanev.nevelotestulet_velemeny"></ion-input>
                        <ion-input style="max-width:190px" label="Fenntartónak megküldve" label-placement="stacked" type="date"
                                   [(ngModel)]="jog.tanev.megkuldve"></ion-input>
                        <ion-input style="max-width:190px" label="A megküldés iktatószáma" label-placement="stacked"
                                   [(ngModel)]="jog.tanev.megkuldes_iktatoszam"></ion-input>
                        <ion-input style="max-width:190px" label="Fenntartó jóváhagyta" label-placement="stacked" type="date"
                                   [(ngModel)]="jog.tanev.jovahagyva"></ion-input>
                        <ion-input style="min-width:220px;flex:1" label="Megjegyzés" label-placement="stacked"
                                   [(ngModel)]="jog.tanev.megjegyzes"></ion-input>
                        <ion-button size="small" [disabled]="jog.mentes" (click)="jog.tanevMent(akttev, sajatIntezmeny.intezmenyId)">Mentés</ion-button>
                      </div>
                      <div style="margin-top:10px;display:flex;flex-wrap:wrap;gap:8px">
                        <ion-button size="small" fill="outline" [disabled]="jog.pdfToltodik" (click)="jog.pdf(akttev, sajatIntezmeny.intezmenyId)">
                          <ion-icon slot="start" name="document-text-outline"></ion-icon>105. § szerinti nyomtatvány (PDF)
                        </ion-button>
                        <ion-button size="small" fill="outline" (click)="jog.sorszamoz(akttev, sajatIntezmeny.intezmenyId)">
                          <ion-icon slot="start" name="list-outline"></ion-icon>Hiányzó sorszámok kiosztása
                        </ion-button>
                        <span style="font-size:.8rem;align-self:center">
                          Összesen: tanórai {{ jog.adat.osszesen?.tanorai }} · egyéb foglalkozás {{ jog.adat.osszesen?.egyeb }} ·
                          ellátott {{ jog.adat.osszesen?.ellatott }} · lekötött {{ jog.adat.osszesen?.lekotott }} óra
                        </span>
                      </div>
                      <ion-note color="warning" *ngIf="jog.adat.hianyzo_adat?.length" style="display:block;margin-top:6px;font-size:.8rem">
                        Hiányzó sorszám / végzettség / szakképzettség: {{ jog.adat.hianyzo_adat.length }} pedagógusnál
                        ({{ jog.adat.hianyzo_adat.slice(0, 6).join(', ') }}<span *ngIf="jog.adat.hianyzo_adat.length > 6">, …</span>).
                      </ion-note>
                    </ion-card-content>
                  </ion-card>

                  <!-- Egy pedagógus szerkesztése -->
                  <ion-card *ngIf="jog.szerk" style="margin:0 0 10px;border:1px solid var(--ion-color-primary)">
                    <ion-card-header><ion-card-subtitle>{{ jog.szerk.nev }}</ion-card-subtitle></ion-card-header>
                    <ion-card-content>
                      <div style="display:flex;flex-wrap:wrap;gap:8px">
                        <ion-input style="max-width:110px" label="Sorszám" label-placement="stacked" type="number" [(ngModel)]="jog.szerk.sorszam"></ion-input>
                        <ion-input style="min-width:200px;flex:1" label="Végzettség" label-placement="stacked" [(ngModel)]="jog.szerk.vegzettseg"
                                   placeholder="pl. egyetem / főiskola"></ion-input>
                        <ion-input style="min-width:260px;flex:2" label="Szakképzettség" label-placement="stacked" [(ngModel)]="jog.szerk.szakkepzettseg"
                                   placeholder="pl. matematika–fizika szakos tanár"></ion-input>
                        <ion-input style="max-width:200px" label="Lekötött óraszám (felülírás)" label-placement="stacked" type="number"
                                   [(ngModel)]="jog.szerk.lekotott_oraszam" [placeholder]="'számított: ' + jog.szerk.lekotott_szamitott"></ion-input>
                        <ion-input style="min-width:220px;flex:1" label="Megjegyzés" label-placement="stacked" [(ngModel)]="jog.szerk.megjegyzes"></ion-input>
                      </div>

                      <h4 style="margin:12px 0 4px">Órakedvezményre jogosító jogcímek</h4>
                      <div *ngFor="let k of jog.szerk.kinevezesek" style="font-size:.85rem">
                        {{ k.nev }} ({{ k.kod }}) – {{ k.ora }} óra <ion-note color="medium">· kinevezés, a Kinevezések képernyőn módosítható</ion-note>
                      </div>
                      <div *ngFor="let j of jog.szerk.jogcimek; let i = index" style="display:flex;flex-wrap:wrap;gap:6px;align-items:flex-end">
                        <ion-input style="min-width:240px;flex:2" label="Jogcím" label-placement="stacked" [(ngModel)]="j.jogcim"></ion-input>
                        <ion-input style="min-width:160px;flex:1" label="Jogszabályhely" label-placement="stacked" [(ngModel)]="j.jogszabaly"></ion-input>
                        <ion-input style="max-width:100px" label="Óra" label-placement="stacked" type="number" [(ngModel)]="j.ora"></ion-input>
                        <ion-button size="small" fill="clear" color="danger" (click)="jog.szerk.jogcimek.splice(i, 1)">
                          <ion-icon slot="icon-only" name="close"></ion-icon>
                        </ion-button>
                      </div>
                      <ion-button size="small" fill="clear" (click)="jog.ujJogcim()"><ion-icon slot="start" name="add-outline"></ion-icon>Jogcím</ion-button>

                      <h4 style="margin:12px 0 4px">Egyéb foglalkozások (amik a tantárgyfelosztás rácsában nem szerepelnek)</h4>
                      <div *ngFor="let e of jog.szerk.egyeb; let i = index" style="display:flex;flex-wrap:wrap;gap:6px;align-items:flex-end">
                        <ion-input style="min-width:240px;flex:2" label="Foglalkozás" label-placement="stacked" [(ngModel)]="e.megnevezes"
                                   placeholder="pl. tehetséggondozás, felzárkóztatás"></ion-input>
                        <ion-input style="min-width:160px;flex:1" label="Osztály / csoport" label-placement="stacked" [(ngModel)]="e.osztaly_csoport"></ion-input>
                        <ion-input style="max-width:100px" label="Heti óra" label-placement="stacked" type="number" [(ngModel)]="e.oraszam"></ion-input>
                        <ion-button size="small" fill="clear" color="danger" (click)="jog.szerk.egyeb.splice(i, 1)">
                          <ion-icon slot="icon-only" name="close"></ion-icon>
                        </ion-button>
                      </div>
                      <ion-button size="small" fill="clear" (click)="jog.ujEgyeb()"><ion-icon slot="start" name="add-outline"></ion-icon>Egyéb foglalkozás</ion-button>

                      <div style="margin-top:10px">
                        <ion-button size="small" [disabled]="jog.mentes" (click)="jog.pedagogusMent(akttev, sajatIntezmeny.intezmenyId)">Mentés</ion-button>
                        <ion-button size="small" fill="clear" (click)="jog.szerk = null">Mégse</ion-button>
                      </div>
                    </ion-card-content>
                  </ion-card>

                  <!-- Pedagógusok -->
                  <div class="scrollable-table">
                    <table class="ttf-jog-tabla" style="width:100%;border-collapse:collapse;font-size:.82rem">
                      <thead>
                        <tr style="text-align:left;border-bottom:1px solid var(--ion-color-medium)">
                          <th>Ssz.</th><th>Név</th><th>Végzettség</th><th>Szakképzettség</th><th>Tantárgyak, foglalkozások</th>
                          <th style="text-align:right">Tanórai</th><th style="text-align:right">Egyéb</th>
                          <th style="text-align:right">Ellátott</th><th style="text-align:right">Lekötött</th>
                          <th>Órakedvezmény jogcímei</th><th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let p of jog.adat.pedagogusok" style="border-bottom:1px solid var(--ion-color-light-shade);vertical-align:top">
                          <td>{{ p.sorszam || '—' }}</td>
                          <td><b>{{ p.nev }}</b><span *ngIf="p.oraado"> <ion-note>óraadó</ion-note></span></td>
                          <td>{{ p.vegzettseg || '—' }}</td>
                          <td>{{ p.szakkepzettseg || '—' }}</td>
                          <td style="max-width:360px">{{ jog.tetelSzoveg(p) || '—' }}</td>
                          <td style="text-align:right">{{ p.tanorai_ora }}</td>
                          <td style="text-align:right">{{ p.egyeb_ora }}</td>
                          <td style="text-align:right"><b>{{ p.ellatott_ora }}</b></td>
                          <td style="text-align:right" [title]="p.lekotott_oraszam !== null ? 'rögzített (számított: ' + p.lekotott_szamitott + ')' : 'számított'">
                            {{ p.lekotott }}<span *ngIf="p.lekotott_oraszam !== null">*</span>
                          </td>
                          <td>{{ jog.kedvezmenySzoveg(p) }}</td>
                          <td><ion-button size="small" fill="clear" (click)="jog.szerkeszt(p)">Szerkeszt</ion-button></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <ion-note color="medium" style="display:block;font-size:.75rem;margin-top:4px">
                    * rögzített lekötött óraszám. A számított érték: 24 × munkaidő-arány − órakedvezmény (óraadónál a szerződés szerinti heti óraszám).
                  </ion-note>
                </ng-container>
              </div>

              <!-- Saját inline modál (NEM ion-modal) a .ttf-work-ön belül, hogy teljes
                   képernyő módban is megjelenjen. -->
              <div class="ttf-modal-overlay" *ngIf="editorOpen && fullscreen" (click)="closeEditor()">
                <div class="ttf-modal-panel" (click)="$event.stopPropagation()">
                  <div class="ttf-modal-head">
                    <span>Csoportok – {{editorRow?.nev}} ({{editorRow?.evfolyam?.osztaly}})</span>
                    <ion-button fill="clear" color="light" (click)="closeEditor()">
                      <ion-icon slot="icon-only" name="close"></ion-icon>
                    </ion-button>
                  </div>
                  <div class="ttf-modal-body">
                    <ion-item lines="none">
                      <ion-label>Bontás (csoportok száma):</ion-label>
                      <ion-input type="number" min="0" [value]="editorGroups.length"
                                 (ionChange)="setGroupCount($event.detail.value)" style="max-width:90px;text-align:center"></ion-input>
                      <ion-button slot="end" fill="outline" (click)="addGroup()">
                        <ion-icon slot="start" name="add"></ion-icon>Új csoport
                      </ion-button>
                    </ion-item>

                    <div class="ttf-gcard" *ngFor="let g of editorGroups; let gi = index">
                      <b *ngIf="!g.egeszOsztaly">{{gi+1}}. csoport</b>
                      <b *ngIf="g.egeszOsztaly">Egész osztály (nincs bontás)</b>
                      <small class="ttf-idegen" *ngIf="g.idegen">
                        Ez a kiírás {{ g.idegenEv ? 'a ' + g.idegenEv + '. tanév' : 'egy törölt' }} csoportjára
                        („{{g.name}}”) mutat, ezért a tanár óraszámába nem számít bele. A régi csoporthoz
                        nem nyúlunk – a kiírást az alábbi gombbal törölheted.
                      </small>
                      <small class="muted" *ngIf="g.egeszOsztaly">Ez a beosztás az egész osztályra szól, ezért nincs hozzá csoportnév, terem és osztály-készlet. A tanárok és a heti óraszám itt is módosítható; ha bontani szeretnéd, vegyél fel új csoportot.</small>
                      <ng-container *ngIf="!g.idegen">
                      <ion-item *ngIf="!g.egeszOsztaly">
                        <ion-label position="stacked">Csoport neve</ion-label>
                        <ion-input [(ngModel)]="g.name" placeholder="pl. Matek 9/1"></ion-input>
                      </ion-item>
                      <ion-item>
                        <ion-label position="stacked">Heti óraszám (párhuzamos csoport → nem összeadódik)</ion-label>
                        <ion-input type="number" min="0" step="0.5" [(ngModel)]="g.db"></ion-input>
                      </ion-item>

                      <!-- Terem: kereshető lista. A bontás MÁSIK csoportja által már
                           lefoglalt terem itt nem választható (párhuzamos órák). -->
                      <ion-label class="editor-section" *ngIf="!g.egeszOsztaly"><b>Terem</b> — {{ roomLabel(g) }}</ion-label>
                      <ion-searchbar *ngIf="!g.egeszOsztaly" placeholder="Terem keresése..." [(ngModel)]="g.teremSearch" [debounce]="150"></ion-searchbar>
                      <div class="room-list" *ngIf="!g.egeszOsztaly">
                        <ion-item button lines="full" (click)="selectRoom(g, null)">
                          <ion-label class="muted">Nincs terem</ion-label>
                          <ion-icon *ngIf="!g.terem" slot="end" name="checkmark" color="primary"></ion-icon>
                        </ion-item>
                        <ng-container *ngIf="filteredRooms(g) as rooms">
                          <ion-item *ngFor="let r of rooms" button [disabled]="isRoomTaken(g, r.id)" (click)="selectRoom(g, r.id)">
                            <ion-label>
                              {{r.name}}<small class="muted" *ngIf="r.rovid && r.rovid != r.name"> ({{r.rovid}})</small>
                              <small class="muted" *ngIf="isRoomTaken(g, r.id)"> – foglalt: {{roomTakenBy(g, r.id)}}. csoport</small>
                            </ion-label>
                            <ion-icon *ngIf="g.terem == r.id" slot="end" name="checkmark" color="primary"></ion-icon>
                          </ion-item>
                          <ion-item *ngIf="rooms.length == 0" lines="none">
                            <ion-label class="muted">{{ termek.length ? 'Nincs találat' : 'Nincs tanterem rögzítve erre a tanévre' }}</ion-label>
                          </ion-item>
                        </ng-container>
                      </div>

                      <ion-label class="editor-section"><b>Tanárok</b> (több is választható – társtanítás) — {{ groupTeacherNames(g) }}</ion-label>
                      <small class="muted" *ngIf="g.origAssignments?.length">Ha minden tanárt leveszel, mentéskor a kiírás törlődik (a csoport megmarad).</small>
                      <ion-searchbar placeholder="Tanár keresése..." [(ngModel)]="teacherSearch" [debounce]="150"></ion-searchbar>
                      <div class="teacher-list">
                        <ng-container>
                          <ion-item *ngFor="let p of filteredTeachers(g)">
                            <ion-label>{{p.viselt_vez}} {{p.viselt_ker}} <small class="muted">({{p.osszora}} ó)</small></ion-label>
                            <ion-checkbox slot="end" [checked]="isTeacherChecked(g, p.adid)" (ionChange)="toggleTeacher(g, p.adid)"></ion-checkbox>
                          </ion-item>
                          <ion-item *ngIf="!filteredTeachers(g).length" lines="none">
                            <ion-label class="muted">Nincs választható munkatárs – a TTF-ben csak a feladatellátásnál engedélyezett (ttf) dolgozók jelennek meg.</ion-label>
                          </ion-item>
                        </ng-container>
                      </div>

                      <ion-label class="editor-section" *ngIf="!g.egeszOsztaly"><b>Osztályok a csoportban</b> (több is választható, akár évfolyamokon át):</ion-label>
                      <div class="class-checks" *ngIf="!g.egeszOsztaly">
                        <ion-chip *ngFor="let o of osztaly" [color]="isClassChecked(g,o.id)?'primary':'medium'" (click)="toggleClass(g,o.id)">
                          <ion-label>{{o.osztaly}}</ion-label>
                          <ion-icon *ngIf="isClassChecked(g,o.id)" name="checkmark"></ion-icon>
                        </ion-chip>
                        <small class="muted" *ngIf="!osztaly?.length">Ehhez a tanévhez még nincs osztály rögzítve.</small>
                      </div>
                      </ng-container>

                      <ion-button color="danger" fill="clear" size="small" (click)="removeGroup(gi)">
                        <ion-icon slot="start" name="trash"></ion-icon>{{ (g.egeszOsztaly || g.idegen) ? 'Kiírás törlése' : 'Csoport / kiírás törlése' }}
                      </ion-button>
                    </div>
                  </div>
                  <div class="ttf-modal-foot">
                    <ion-button expand="block" (click)="saveEditor()" [disabled]="savingEditor">
                      <ion-icon slot="start" name="save"></ion-icon>{{ savingEditor ? 'Mentés...' : 'Mentés' }}
                    </ion-button>
                  </div>
                </div>
              </div>

             </div><!-- /.ttf-work -->
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>

    <!-- Nem-teljes-képernyős módban a RÉGI ion-modal (portál, viewporthoz igazít) -->
    <ion-modal [isOpen]="editorOpen && !fullscreen" (didDismiss)="closeEditor()">
      <ng-template>
        <ion-header>
          <ion-toolbar color="primary">
            <ion-title>Csoportok – {{editorRow?.nev}} ({{editorRow?.evfolyam?.osztaly}})</ion-title>
            <ion-buttons slot="end">
              <ion-button (click)="closeEditor()"><ion-icon slot="icon-only" name="close"></ion-icon></ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
          <ion-item lines="none">
            <ion-label>Bontás (csoportok száma):</ion-label>
            <ion-input type="number" min="0" [value]="editorGroups.length"
                       (ionChange)="setGroupCount($event.detail.value)" style="max-width:90px;text-align:center"></ion-input>
            <ion-button slot="end" fill="outline" (click)="addGroup()">
              <ion-icon slot="start" name="add"></ion-icon>Új csoport
            </ion-button>
          </ion-item>

          <ion-card *ngFor="let g of editorGroups; let gi = index">
            <ion-card-header>
              <ion-card-subtitle *ngIf="!g.egeszOsztaly">{{gi+1}}. csoport</ion-card-subtitle>
              <ion-card-subtitle *ngIf="g.egeszOsztaly">Egész osztály (nincs bontás) – nincs csoportnév, terem és osztály-készlet; a tanárok és az óraszám módosítható</ion-card-subtitle>
            </ion-card-header>
            <ion-card-content>
              <p class="ttf-idegen" *ngIf="g.idegen">
                Ez a kiírás {{ g.idegenEv ? 'a ' + g.idegenEv + '. tanév' : 'egy törölt' }} csoportjára
                („{{g.name}}”) mutat, ezért a tanár óraszámába nem számít bele. A régi csoporthoz
                nem nyúlunk – a kiírást az alábbi gombbal törölheted.
              </p>
              <ng-container *ngIf="!g.idegen">
              <ion-item *ngIf="!g.egeszOsztaly">
                <ion-label position="stacked">Csoport neve</ion-label>
                <ion-input [(ngModel)]="g.name" placeholder="pl. Matek 9/1"></ion-input>
              </ion-item>
              <ion-item>
                <ion-label position="stacked">Heti óraszám (párhuzamos csoport → nem összeadódik)</ion-label>
                <ion-input type="number" min="0" step="0.5" [(ngModel)]="g.db"></ion-input>
              </ion-item>

              <!-- Terem: kereshető lista. A bontás MÁSIK csoportja által már
                   lefoglalt terem itt nem választható (párhuzamos órák). -->
              <ion-label class="editor-section" *ngIf="!g.egeszOsztaly"><b>Terem</b> — {{ roomLabel(g) }}</ion-label>
              <ion-searchbar *ngIf="!g.egeszOsztaly" placeholder="Terem keresése..." [(ngModel)]="g.teremSearch" [debounce]="150"></ion-searchbar>
              <div class="room-list" *ngIf="!g.egeszOsztaly">
                <ion-item button lines="full" (click)="selectRoom(g, null)">
                  <ion-label class="muted">Nincs terem</ion-label>
                  <ion-icon *ngIf="!g.terem" slot="end" name="checkmark" color="primary"></ion-icon>
                </ion-item>
                <ng-container *ngIf="filteredRooms(g) as rooms">
                  <ion-item *ngFor="let r of rooms" button [disabled]="isRoomTaken(g, r.id)" (click)="selectRoom(g, r.id)">
                    <ion-label>
                      {{r.name}}<small class="muted" *ngIf="r.rovid && r.rovid != r.name"> ({{r.rovid}})</small>
                      <small class="muted" *ngIf="isRoomTaken(g, r.id)"> – foglalt: {{roomTakenBy(g, r.id)}}. csoport</small>
                    </ion-label>
                    <ion-icon *ngIf="g.terem == r.id" slot="end" name="checkmark" color="primary"></ion-icon>
                  </ion-item>
                  <ion-item *ngIf="rooms.length == 0" lines="none">
                    <ion-label class="muted">{{ termek.length ? 'Nincs találat' : 'Nincs tanterem rögzítve erre a tanévre' }}</ion-label>
                  </ion-item>
                </ng-container>
              </div>

              <ion-label class="editor-section"><b>Tanárok</b> (több is választható – társtanítás) — {{ groupTeacherNames(g) }}</ion-label>
              <small class="muted" *ngIf="g.origAssignments?.length">Ha minden tanárt leveszel, mentéskor a kiírás törlődik (a csoport megmarad).</small>
              <ion-searchbar placeholder="Tanár keresése..." [(ngModel)]="teacherSearch" [debounce]="150"></ion-searchbar>
              <div class="teacher-list">
                <ng-container>
                  <ion-item *ngFor="let p of filteredTeachers(g)">
                    <ion-label>{{p.viselt_vez}} {{p.viselt_ker}} <small class="muted">({{p.osszora}} ó)</small></ion-label>
                    <ion-checkbox slot="end" [checked]="isTeacherChecked(g, p.adid)" (ionChange)="toggleTeacher(g, p.adid)"></ion-checkbox>
                  </ion-item>
                  <ion-item *ngIf="!filteredTeachers(g).length" lines="none">
                    <ion-label class="muted">Nincs választható munkatárs – a TTF-ben csak a feladatellátásnál engedélyezett (ttf) dolgozók jelennek meg.</ion-label>
                  </ion-item>
                </ng-container>
              </div>

              <ion-label class="editor-section" *ngIf="!g.egeszOsztaly"><b>Osztályok a csoportban</b> (több is választható, akár évfolyamokon át):</ion-label>
              <div class="class-checks" *ngIf="!g.egeszOsztaly">
                <ion-chip *ngFor="let o of osztaly" [color]="isClassChecked(g,o.id)?'primary':'medium'" (click)="toggleClass(g,o.id)">
                  <ion-label>{{o.osztaly}}</ion-label>
                  <ion-icon *ngIf="isClassChecked(g,o.id)" name="checkmark"></ion-icon>
                </ion-chip>
                <small class="muted" *ngIf="!osztaly?.length">Ehhez a tanévhez még nincs osztály rögzítve.</small>
              </div>
              </ng-container>

              <ion-button color="danger" fill="clear" size="small" (click)="removeGroup(gi)">
                <ion-icon slot="start" name="trash"></ion-icon>{{ (g.egeszOsztaly || g.idegen) ? 'Kiírás törlése' : 'Csoport / kiírás törlése' }}
              </ion-button>
            </ion-card-content>
          </ion-card>

          <ion-button expand="block" (click)="saveEditor()" [disabled]="savingEditor">
            <ion-icon slot="start" name="save"></ion-icon>{{ savingEditor ? 'Mentés...' : 'Mentés' }}
          </ion-button>
        </ion-content>
      </ng-template>
    </ion-modal>
  </ng-container>

</ion-content>

<!-- ── Visszatöltés az órarendből ──────────────────────────────────────────────
     Két lépés: előbb megmutatja, mi keletkezne, és csak a második kattintás ír. -->
<ion-modal [isOpen]="vtNyitva" (didDismiss)="vtNyitva = false">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title>Tantárgyfelosztás visszatöltése az órarendből</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="vtNyitva = false">Bezár</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-note color="medium" style="display:block;font-size:12.5px;line-height:1.6;max-width:82ch;margin-bottom:14px">
        Ami az órarendben áll, az <b>tény</b>: ott valaki tényleg tart órát. Ez a művelet a
        meglévő órarendből pótolja a hiányzó felosztás-sorokat — a heti óraszámot a heti
        kártyák számából veszi. <b>Nem töröl és nem ír felül semmit:</b> a meglévő
        sorokhoz akkor sem nyúl, ha az óraszámuk eltér az órarendtől, mert a felosztás
        emberi döntés is (megbízás, elszámolás), az órarend pedig változhat egy hét erejéig.
      </ion-note>

      <div *ngIf="vtToltodik">Elemzés…</div>

      <ng-container *ngIf="vtAdat && !vtToltodik">
        <p style="font-size:13px">
          <b>{{ vtAdat.ev }}/{{ vtAdat.ev + 1 }}</b> tanév
          ({{ vtAdat.ablak.tol }} – {{ vtAdat.ablak.ig }})
        </p>
        <ul style="font-size:13px;line-height:1.8">
          <li>Az órarendben <b>{{ vtAdat.osszegzes.orarend_harmas }}</b> tanár–tantárgy–évfolyam bontás van.</li>
          <li>Ebből <b>{{ vtAdat.osszegzes.megvan }}</b> ugyanazzal az óraszámmal szerepel a felosztásban.</li>
          <li *ngIf="vtAdat.osszegzes.elter">
            <b>{{ vtAdat.osszegzes.elter }}</b> szerepel, de <b>más óraszámmal</b>, mint az órarendben (lásd lent).
          </li>
          <li *ngIf="vtAdat.osszegzes.tobblet">
            <b>{{ vtAdat.osszegzes.tobblet }}</b> felosztás-sor mögött <b>nincs</b> órarendi óra (lásd lent).
          </li>
          <li><b>{{ vtAdat.osszegzes.uj }}</b> hiányzik, és felvehető.</li>
          <li *ngIf="vtAdat.osszegzes.nincs_kerettanterv">
            <b>{{ vtAdat.osszegzes.nincs_kerettanterv }}</b> sorhoz nincs kerettanterv-sor —
            felosztás-sort csak úgy lehet felvenni, ha megnyitjuk azt is.
          </li>
          <li>Érintett munkatárs: <b>{{ vtAdat.osszegzes.erintett_munkatars }}</b>.</li>
        </ul>

        <ion-checkbox labelPlacement="end" [(ngModel)]="vtKerettanterv" style="font-size:13px"
                      *ngIf="vtAdat.osszegzes.nincs_kerettanterv">
          A hiányzó kerettanterv-sorokat is nyissuk meg (az óraszám az órarendből jön, utólag javítható)
        </ion-checkbox>

        <div style="margin:14px 0">
          <ion-button color="primary" [disabled]="vtFut || !vtHianyzo.length" (click)="visszatoltesIndit()">
            <ion-icon slot="start" name="download-outline"></ion-icon>
            {{ vtFut ? 'Fut…' : 'Hiányzók pótlása' }}
          </ion-button>
          <span *ngIf="!vtHianyzo.length && !vtElteres.length && !vtTobblet.length" style="font-size:13px;color:#1f7a45;margin-left:10px">
            Nincs mit pótolni — az órarend minden órája mögött ugyanannyi órás felosztás-sor van.
          </span>
          <span *ngIf="!vtHianyzo.length && (vtElteres.length || vtTobblet.length)" style="font-size:13px;color:#8a5b00;margin-left:10px">
            Hiányzó sor nincs, de az óraszámok nem mindenhol egyeznek — lásd lent.
          </span>
        </div>

        <div *ngIf="vtEredmeny" style="font-size:13px;padding:10px;border-radius:8px;background:#f2fbf5;margin-bottom:14px">
          <b>{{ vtEredmeny.ttf_uj }}</b> felosztás-sor és
          <b>{{ vtEredmeny.kerettanterv_uj }}</b> kerettanterv-sor létrehozva.
          <span *ngIf="vtEredmeny.kihagyva"> Kihagyva: {{ vtEredmeny.kihagyva }}.</span>
          <div *ngFor="let h of vtEredmeny.hibak" style="color:#8a5b00">{{ h.sor }} — {{ h.ok }}</div>
        </div>

        <table style="width:100%;border-collapse:collapse;font-size:12.5px" *ngIf="vtHianyzo.length">
          <thead>
            <tr style="text-align:left;color:#6b7a90;font-size:11px;text-transform:uppercase">
              <th style="padding:6px 8px">Munkatárs</th>
              <th style="padding:6px 8px">Tantárgy</th>
              <th style="padding:6px 8px">Évf.</th>
              <th style="padding:6px 8px">Osztály / csoport</th>
              <th style="padding:6px 8px">Heti óra</th>
              <th style="padding:6px 8px">Állapot</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let s of vtHianyzo" style="border-bottom:1px solid #eef1f6">
              <td style="padding:6px 8px">{{ s.munkatars }}</td>
              <td style="padding:6px 8px">{{ s.tantargy_nev }}</td>
              <td style="padding:6px 8px">{{ s.evfolyam }}</td>
              <td style="padding:6px 8px">{{ s.csoport_nev || s.osztalyok }}</td>
              <td style="padding:6px 8px">{{ s.heti }}</td>
              <td style="padding:6px 8px">
                <span *ngIf="s.allapot === 'uj'" style="color:#2a5db0">felvehető</span>
                <span *ngIf="s.allapot === 'nincs_kerettanterv'" style="color:#8a5b00">kerettanterv is kell</span>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Eltérő óraszám: a felosztáshoz NEM nyúlunk, csak megmutatjuk. -->
        <ng-container *ngIf="vtElteres.length">
          <h4 style="font-size:13.5px;margin:18px 0 6px">Eltérő óraszám (felosztás ≠ órarend)</h4>
          <table style="width:100%;border-collapse:collapse;font-size:12.5px">
            <thead>
              <tr style="text-align:left;color:#6b7a90;font-size:11px;text-transform:uppercase">
                <th style="padding:6px 8px">Munkatárs</th>
                <th style="padding:6px 8px">Tantárgy</th>
                <th style="padding:6px 8px">Évf.</th>
                <th style="padding:6px 8px">Osztály / csoport</th>
                <th style="padding:6px 8px">Órarend</th>
                <th style="padding:6px 8px">Felosztás</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let s of vtElteres" style="border-bottom:1px solid #eef1f6">
                <td style="padding:6px 8px">{{ s.munkatars }}</td>
                <td style="padding:6px 8px">{{ s.tantargy_nev }}</td>
                <td style="padding:6px 8px">{{ s.evfolyam }}</td>
                <td style="padding:6px 8px">{{ s.csoport_nev || s.osztalyok }}</td>
                <td style="padding:6px 8px">{{ s.heti }}</td>
                <td style="padding:6px 8px;color:#8a5b00">{{ s.ttf_db }}</td>
              </tr>
            </tbody>
          </table>
        </ng-container>

        <!-- Többlet: felosztás-sor, ami mögött nincs óra. A rácsban a Szerkesztéssel törölhető. -->
        <ng-container *ngIf="vtTobblet.length">
          <h4 style="font-size:13.5px;margin:18px 0 6px">Felosztás-sor órarendi óra nélkül</h4>
          <ion-note color="medium" style="display:block;font-size:12px;margin-bottom:6px">
            Ha a kiírás már nem érvényes, a rácsban a sor <b>Szerkesztés</b> gombjával törölheted
            („Kiírás törlése”, vagy minden tanár levétele és mentés).
          </ion-note>
          <table style="width:100%;border-collapse:collapse;font-size:12.5px">
            <thead>
              <tr style="text-align:left;color:#6b7a90;font-size:11px;text-transform:uppercase">
                <th style="padding:6px 8px">Munkatárs</th>
                <th style="padding:6px 8px">Tantárgy</th>
                <th style="padding:6px 8px">Évf.</th>
                <th style="padding:6px 8px">Csoport</th>
                <th style="padding:6px 8px">Heti óra</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let s of vtTobblet" style="border-bottom:1px solid #eef1f6">
                <td style="padding:6px 8px">{{ s.munkatars }}</td>
                <td style="padding:6px 8px">{{ s.tantargy_nev }}</td>
                <td style="padding:6px 8px">{{ s.evfolyam }}</td>
                <td style="padding:6px 8px">
                  {{ s.csoport_nev || 'egész osztály' }}
                  <small *ngIf="s.masik_tanev" style="color:#8a5b00"> ({{ s.masik_tanev }}. tanévi csoport)</small>
                </td>
                <td style="padding:6px 8px">{{ s.db }}</td>
              </tr>
            </tbody>
          </table>
        </ng-container>
      </ng-container>
    </ion-content>
  </ng-template>
</ion-modal>
